import type { ProjectSchemaJSON } from '@takeshape/schema';
import type { ProjectSchemaCompat, ProjectSchemaCompatMetadata, ProjectSchemaRecord } from './types';

export function schemaRecordToCompatSchema(schemaRecord: ProjectSchemaRecord): ProjectSchemaCompat {
  const { schema, version, created, updated, schemaHash } = schemaRecord;
  return {
    ...schema,
    version,
    created,
    updated,
    schemaHash
  };
}

export function compatSchemaToSchema(compatSchema: ProjectSchemaCompat): ProjectSchemaJSON {
  const { version, created, updated, schemaHash, ...schema } = compatSchema;
  return schema;
}

/**
 * Adds mock data. Only intended for tests.
 */
export function mockCompatSchema(schema: ProjectSchemaJSON): ProjectSchemaCompat {
  return {
    ...schema,
    version: 1,
    created: '2023-04-25T22:37:32.287Z',
    updated: '2023-04-25T22:37:32.287Z',
    schemaHash: 'schema-hash'
  };
}

export function pickCompatMetadata(compatSchema: ProjectSchemaCompat): ProjectSchemaCompatMetadata {
  const { version, created, updated, schemaHash } = compatSchema;
  return { version, created, updated, schemaHash };
}
